import { defineComponent, ref, computed, createElementBlock, openBlock, normalizeClass, createBlock, createCommentVNode, renderSlot, createTextVNode } from 'vue';
import { useIntersectionObserver } from './basler-components.es354.js';
import _sfc_main$1 from './basler-components.es79.js';
/* empty css                       */

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Badge",
  props: {
    badgeStyle: { default: "primary" },
    isRounded: { type: Boolean, default: true },
    isRound: { type: Boolean, default: false },
    iconName: { default: "" },
    iconType: { default: "no-icon" },
    size: { default: "medium" },
    hasShineAnimation: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const badgeRef = ref(null);
    const isVisible = ref(false);
    const isRounded = computed(() => !props.isRound && props.isRounded);
    useIntersectionObserver(badgeRef, ([{ isIntersecting }]) => {
      isVisible.value = isIntersecting;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        ref_key: "badgeRef",
        ref: badgeRef,
        class: normalizeClass([
          "badge",
          `is-${_ctx.size}`,
          `badge--${_ctx.iconType}`,
          `is-${_ctx.badgeStyle}`,
          {
            ["is-rounded"]: isRounded.value,
            ["is-round"]: _ctx.isRound,
            ["has-shine-animation"]: _ctx.hasShineAnimation,
            ["is-visible"]: isVisible.value
          }
        ])
      }, [
        _ctx.iconType === "icon-left" && _ctx.iconName ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          name: _ctx.iconName,
          size: "dynamic"
        }, null, 8, ["name"])) : createCommentVNode("", true),
        _ctx.iconType !== "icon-only" ? renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          _cache[0] || (_cache[0] = createTextVNode("Badge"))
        ]) : _ctx.iconName ? (openBlock(), createBlock(_sfc_main$1, {
          key: 2,
          name: _ctx.iconName,
          size: "dynamic"
        }, null, 8, ["name"])) : createCommentVNode("", true),
        _ctx.iconType === "icon-right" && _ctx.iconName ? (openBlock(), createBlock(_sfc_main$1, {
          key: 3,
          name: _ctx.iconName,
          size: "dynamic"
        }, null, 8, ["name"])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
